/** @format */

import { Chain, CompareProductDetails, Environment } from '@shared/data-access/interfaces';
import { CustomHttpHeaders, MediaType } from '@shared/data-access/enums';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, catchError, retry, throwError } from 'rxjs';

import  { HttpService } from '@shared/data-access/services';
import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class ProductListCompareDao {
	constructor(
		private readonly httpService: HttpService,
		private readonly environment: Environment,
		private readonly chain: Chain,
		private readonly http: HttpClient,
	) {}

	getProductDetails(
		ecodes: string[],
		selectedStore: string,
		isClearance = false,
		retries = 1
	): Observable<CompareProductDetails> {
		let httpRequestParams = new HttpParams();

		httpRequestParams = httpRequestParams
			.set('ecode', ecodes.join(','))
			.set('inventory', 'true')
			.set('selectedStore', selectedStore)
			.set('clearance', isClearance);

		let httpHeaders = new HttpHeaders({
			Accept: MediaType.APPLICATION_JSON
		});

		// Get Origin Host Header
		const origin = this.httpService.getRequestHeaderValueAndSetStateKey('ORIGIN_HOST');
		if (origin) {
			httpHeaders = httpHeaders.set(CustomHttpHeaders.ORIGIN, origin);

		}

		const httpOptions = {
			httpHeaders,
			params: httpRequestParams,
			withCredentials: false
		};

		return this.http
			.get<CompareProductDetails>(
				`${this.environment.api.seoByChain}catalog-productdetails/v4/store/${this.chain.storeId}/products`,
				httpOptions
			)
			.pipe(
				catchError((error) => throwError(() => error)
				),
				retry(retries)
			);
	}
}
